var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCreateMessage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_1239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_1239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03241 6.14978C6.48888 6.45466 7.02555 6.61738 7.57455 6.61738C8.12355 6.61738 8.66021 6.45466 9.11669 6.14978L13.7684 3.096C13.4652 2.46909 12.9916 1.94009 12.4019 1.56945C11.8121 1.19882 11.13 1.00148 10.4333 1H4.71273C4.03075 1.00078 3.36215 1.18928 2.78027 1.54483C2.19839 1.90039 1.72571 2.40926 1.41406 3.01564L6.03241 6.14978Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.8999,
    y: 8.40002,
    width: 6,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57156 7.62912C8.32059 7.62912 9.05278 7.40697 9.67545 6.99079L14.0905 4.09319C14.1262 4.29733 14.1448 4.50409 14.1461 4.71133V7.59798C13.754 7.46951 13.335 7.40002 12.8999 7.40002C10.6908 7.40002 8.8999 9.19089 8.8999 11.4C8.8999 12.0198 9.04084 12.6066 9.29242 13.1302H4.71278C3.72842 13.1291 2.78468 12.7378 2.08863 12.042C1.39258 11.3462 1.00107 10.4028 1 9.41886V4.71133C1.00035 4.47432 1.02337 4.23788 1.06876 4.00525L5.46767 6.99079C6.09033 7.40697 6.82252 7.62912 7.57156 7.62912Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8734 9.6495C14.7345 9.52652 14.5465 9.45746 14.3504 9.45746C14.1544 9.45746 13.9663 9.52652 13.8275 9.6495L11.4185 11.79C11.394 11.8118 11.3748 11.8378 11.362 11.8664C11.2863 12.0371 11.2003 12.2126 11.1173 12.3821C11.0314 12.5576 10.9426 12.7393 10.8611 12.9221C10.8459 12.9563 10.8403 12.9933 10.8448 13.0298C10.8493 13.0663 10.8639 13.1013 10.8871 13.1317C10.9104 13.1621 10.9417 13.187 10.9783 13.2042C11.0148 13.2214 11.0556 13.2303 11.097 13.2303C11.1289 13.2303 11.1605 13.225 11.1902 13.2144C11.5097 13.1021 11.8046 12.9891 12.1168 12.8697C12.2053 12.8356 12.2946 12.8014 12.3847 12.7672C12.4144 12.7559 12.4415 12.7396 12.4643 12.7192L14.8733 10.5787C15.0119 10.4555 15.0897 10.2883 15.0897 10.1141C15.0897 9.93985 15.0119 9.77279 14.8734 9.6495ZM12.1404 12.37L13.6323 11.0443L13.304 10.7522L11.8142 12.0759C11.7404 12.239 11.6605 12.4029 11.5824 12.5618C11.5783 12.5705 11.5742 12.5793 11.5697 12.588C11.6842 12.5446 11.799 12.5007 11.9159 12.4556C11.9904 12.4274 12.0649 12.3988 12.1404 12.37ZM14.5149 10.2602C14.5584 10.2214 14.5829 10.1689 14.5828 10.1141C14.5828 10.0594 14.5583 10.0069 14.5147 9.96819C14.471 9.92949 14.4119 9.90777 14.3503 9.90781C14.2887 9.90784 14.2296 9.92963 14.186 9.96838L13.6623 10.4337L13.9911 10.7255L14.5149 10.2602Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreateMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/create_message.3b4e86be.svg";
export { ForwardRef as ReactComponent };